import React from "react";
import "./select.scss";

const SelectMenu = ({
    options = [],
    onSelect,
    selectedValue,
    name,
    disabled = false,
    defaultOption = "Any Weapon",
    isOpen,
    setIsOpen
}) => {
    const handleSelect = (option) => {
        onSelect({ target: { name: name, value: option } });
        setIsOpen(null); // Close after selection
    };

    return (
        <div className="select-menu">
            <div
                className={`select-box ${disabled ? "disabled light-gray" : ""} ${selectedValue ? "select-box-active" : ""}`.trim()}
                onClick={() => !disabled && setIsOpen(name)}
            >
                <span className="defaultOption-style">
                    {selectedValue || defaultOption}
                </span>
                <span className={`select-arrow ${isOpen ? "select-up" : "select-down"} ${selectedValue ? 'select-arrow-active' : ''} ${disabled ? 'light-gray-border' : ''}`}></span>
            </div>

            {isOpen
                && !disabled
                && (
                    <ul className="options-list">
                        {selectedValue && (
                            <li className="option-item" onClick={() => handleSelect("")}>
                                {defaultOption}
                            </li>
                        )}

                        {options.length > 0 ? [...options]
                            .sort((a, b) => a.localeCompare(b))
                            .map((option, index) => (
                                <li key={index} className="option-item" onClick={() => handleSelect(option)}>
                                    {option}
                                </li>
                            )) :
                            <>
                                <li className="option-item-no-hunt" style={{ cursor: 'default' }}> </li>
                                <li className="option-item-no-hunt" style={{ cursor: 'default' }}> </li>
                                <li className="option-item-no-hunt" style={{ cursor: 'default' }}> </li>
                            </>
                        }
                    </ul>
                )}
        </div>
    );
};

export default SelectMenu;


